import BaseDialog from '../../common/BaseDialog';
import { FormattedMessage, useIntl } from 'react-intl';
import { DialogButton } from '@rmwc/dialog';
import RadioField from '../../common/RadioField';
import React, { useState } from 'react';
import moment from "moment";
import ProductType from '../../../const/productType';
import AlertMessage from '../../common/AlertMessage';
import { Grid, GridCell } from '@rmwc/grid';

const VariableProductSelectDialog = ({ isOpen, onClose, item, selectedDatePeriods, onDatePeriodSelect }) => {
    const [dates, setDates] = useState([]);
    const intl = useIntl();

    React.useEffect(() => {
        const updateDates = () => {
            let months = [];
            let monthsRequired = 12

            for (let i = 1; i <= monthsRequired; i++) {
                months.push(moment().add(i, 'months').startOf('month'))
            }

            setDates(months);
        }

        updateDates();
    }, [])

    if (!isOpen) return null;

    const renderDialogActions = () => {
        return (
            <div>
                <DialogButton action="accept" className="mdc-button mdc-button--unelevated" isDefaultAction>
                    <FormattedMessage id="General.Select" />
                </DialogButton>
            </div>
        )
    }

    const getStockProduct = () => {
        return item.type === ProductType.StockPrice ? item : item.connectedProduct;
    }

    const getFixedProduct = () => {
        return item.type === ProductType.StockPrice ? item.connectedProduct : item;
    }

    const renderPriceColumn = (item, index) => {
        const selectedValue = selectedDatePeriods[index];

        switch (selectedValue?.type) {
            case ProductType.FixedPrice:
                return intl.formatMessage({ id: 'Product.VariableProduct.Price.FixedPrice'}, { margin: getFixedProduct().marginal });
            case ProductType.StockPrice:
                return intl.formatMessage({ id: 'Product.VariableProduct.Price.StockPrice' }, { margin: getStockProduct().marginal });
            default:
                return intl.formatMessage({ id: 'Product.VariableProduct.Price.Select' });
        }
    }

    const renderRow = (date, index) => {
        return (
            <tr key={`variableProduct_${index}`}>
                <td>{date.format('MMMM YYYY')}</td>
                <td>{renderPriceColumn(item, index)}</td>
                <td>
                    <RadioField
                        wrapperClasses={"override-mdc-form-field"}
                        index={index}
                        fieldName={`variableProduct_${index}`}
                        fieldValue={ProductType.StockPrice}
                        selectedValue={selectedDatePeriods[index]?.type}
                        disabled={false}
                        onChange={() => {
                            onDatePeriodSelect({
                                ...selectedDatePeriods,
                                [index]: {
                                    date: date.format('YYYY-MM-DD'),
                                    type: ProductType.StockPrice,
                                    productId: getStockProduct().id,
                                }
                            });
                        }}
                    />
                </td>
                <td>
                    <RadioField
                        wrapperClasses={"override-mdc-form-field"}
                        index={index}
                        fieldName={`variableProduct_${index}`}
                        fieldValue={ProductType.FixedPrice}
                        selectedValue={selectedDatePeriods[index]?.type}
                        disabled={false}
                        onChange={() => {
                            onDatePeriodSelect({
                                ...selectedDatePeriods,
                                [index]: {
                                    date: date.format('YYYY-MM-DD'),
                                    type: ProductType.FixedPrice,
                                    productId: getFixedProduct().id,
                                }
                            });
                        }}
                    /></td>
            </tr>
        )
    }

    return (
        <>
            <BaseDialog isOpen={isOpen} onClose={onClose} dialogActions={renderDialogActions()} className="mdc-dialog--wide">
                <Grid>
                    <GridCell span={12}>
                        <AlertMessage
                            type={AlertMessage.TYPE_NOTICE}
                            title={intl.formatMessage({ id: "Product.VariableProduct.Disclaimer" })}
                            isSmall
                        />
                    </GridCell>
                    <GridCell span={12}>
                        <table className="table-list">
                            <thead>
                            <tr>
                                <th width="20%">
                                    <FormattedMessage id="Product.VariableProduct.Header.Month" />
                                </th>
                                <th width="60%">
                                    <FormattedMessage id="Product.VariableProduct.Header.Price" />
                                </th>
                                <th><FormattedMessage id={`ProductType.${ProductType.StockPrice}`} /></th>
                                <th><FormattedMessage id={`ProductType.${ProductType.FixedPrice}`} /></th>
                            </tr>
                            </thead>
                            <tbody>
                            { dates.map((date, index) => renderRow(date, index)) }
                            </tbody>
                        </table>
                    </GridCell>
                </Grid>
            </BaseDialog>
        </>
    );
};

export default VariableProductSelectDialog;